import http from '@/services/rest/rest.service';
import { IAdminAccountModel, IAdminEditModel } from '@/entities';

export default {
    list(): Promise<IAdminAccountModel[]> {
        return http.get('admins');
    },
    get(id: number): Promise<IAdminAccountModel> {
        return http.get(`admins/${id}`);
    },
    create(model: IAdminEditModel): Promise<number> {
        return http.put(`admins`, model);
    },
    update(id: number, model: IAdminEditModel): Promise<number> {
        return http.post(`admins/${id}`, model);
    },
    countToMigrate(): Promise<number> {
        return http.get(`admins/countToMigrate`);
    }
};
